/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S8_BodyInputs */

const en_fc_tut_s8_body = /** @type {(inputs: Fc_Tut_S8_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance levels in the Audio Clip Mixer and add automation for fades and ducking. Watch the EBU R128 loudness meters: around -14 LUFS suits most online platforms, and -23 LUFS is the broadcast standard.`)
};

/**
* | output |
* | --- |
* | "Balance levels in the Audio Clip Mixer and add automation for fades and ducking. Watch the EBU R128 loudness meters: around -14 LUFS suits most online platfo..." |
*
* @param {Fc_Tut_S8_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s8_body = /** @type {((inputs?: Fc_Tut_S8_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S8_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s8_body(inputs)
});
export { fc_tut_s8_body as "fc.tut.s8.body" }